<template>
  <div class="consultation">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="70%"
      @close="setDialogClosed" append-to-body>
      <el-container class="container" direction="vertical">
        <el-descriptions :column="4" border>
          <el-descriptions-item :span="2" label="姓名">
            {{ lastPageValue.patientName }}
          </el-descriptions-item>

          <el-descriptions-item :span="2" label="住址">
            {{ lastPageValue.address }}
          </el-descriptions-item>

          <el-descriptions-item span="2" label="身份证号">
            {{ lastPageValue.idcard }}
          </el-descriptions-item>

          <el-descriptions-item span="2" label="患者电话">
            {{ lastPageValue.phone }}
          </el-descriptions-item>

          <el-descriptions-item span="2" label="联系人">
            {{ lastPageValue.contactName }}
          </el-descriptions-item>

          <el-descriptions-item span="2" label="联系人电话">
            {{ lastPageValue.contactPhone }}
          </el-descriptions-item>

          <el-descriptions-item span="4" label="诊断">
            {{ lastPageValue.applyDiagnosis }}
          </el-descriptions-item>

          <el-descriptions-item span="4" label="转诊信息">
            <el-descriptions :column="4" border>
              <el-descriptions-item span="2" label="转诊医师">
                {{ lastPageValue.applyDoctorName }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="所属机构">
                {{ lastPageValue.applyHospital }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="所属科室">
                {{ lastPageValue.applyDeptName ? lastPageValue.applyDeptName : "尚未建立所属科室信息" }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="所属机构电话">
                {{ lastPageValue.applyHospitalPhone ? lastPageValue.applyHospitalPhone : "尚未建立机构电话信息" }}
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>

          <el-descriptions-item span="4" label="处置方式">
            {{ listQueryData.codiagDealResult }}
          </el-descriptions-item>

          <template v-if="listQueryData.codiagDealResult == '线上协诊'">
            <el-descriptions-item span="4" label="用药指导">
              <el-descriptions :column="1" border>
                <el-descriptions-item label="用药" v-for="(item, index) in listQueryData.medicines" :key="index">
                  <el-descriptions :column="4" border>
                    <el-descriptions-item span="2" label="药物名称">
                      {{ item.medicineName }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="用药次数/日">
                      {{ item.freq }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="用量/次">
                      {{ item.dosage }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="用药时间">
                      {{ item.takeMethod }}
                    </el-descriptions-item>
                    <el-descriptions-item span="4" label="注意事项">
                      {{ item.remarks }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="饮食指导">
              {{ listQueryData.dietGuides }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="其他建议">
              {{ listQueryData.dietAdvice }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="生活方式指导">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="4" label="日吸烟量指导(支/天)">
                  {{ listQueryData.smokePerdayTarget }}
                </el-descriptions-item>
                <el-descriptions-item span="4" label="日饮酒量指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="饮酒品类">
                      {{ listQueryData.drinkType }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="饮酒量">
                      {{ listQueryData.drinkPerdayTarget }}{{ listQueryData.drinkUnit }}
                    </el-descriptions-item>

                  </el-descriptions>
                </el-descriptions-item>
                <el-descriptions-item :span="4" label="运动行为指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="运动形式">
                      {{ listQueryData.sportType }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动时间">
                      {{ listQueryData.sportPeriodGuides }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动时长">
                      {{ listQueryData.sportMinutesEach }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动频次">
                      {{ listQueryData.sportFreq }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="2" label="复查时间">
              {{ listQueryData.reviewTime }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="复查频次">
              {{ listQueryData.reviewFreq }}
            </el-descriptions-item>
          </template>

          <template v-if="listQueryData.codiagDealResult == '门诊'">
            <el-descriptions-item span="4" label="*门诊治疗">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="2" label="*检查">
                  {{ listQueryData.exams }}
                </el-descriptions-item>
                <el-descriptions-item span="2" label="*检验">
                  {{ listQueryData.tests }}
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*其他建议">
              {{ listQueryData.outpatientAdvice }}
            </el-descriptions-item>
          </template>

          <template v-if="listQueryData.codiagDealResult == '住院'">
            <el-descriptions-item span="4" label="*住院指导">
              {{ listQueryData.inpatientGuides }}
            </el-descriptions-item>
            <el-descriptions-item span="4" label="*其他建议">
              {{ listQueryData.inpatientAdvice }}
            </el-descriptions-item>
          </template>

          <el-descriptions-item span="4" label="协诊信息">
            <el-descriptions :column="4" border>
              <el-descriptions-item span="2" label="协诊医师">
                {{ lastPageValue.codiagDoctorName }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊机构">
                {{ lastPageValue.codiagHospital }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊科室">
                {{ lastPageValue.codiagDeptName ? lastPageValue.codiagDeptName : "尚未建立协诊科室" }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊机构电话">
                {{ lastPageValue.codiagHospitalPhone ? lastPageValue.codiagHospitalPhone : "尚未建立机构电话" }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊日期">
                {{ lastPageValue.codiagTime }}
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "协诊记录表",
      showDialog: null,
      lastPageValue: {},
      listQueryData: {}
    }
  },
  watch: {},
  created() { },
  methods: {
    // 初始化界面
    async init(value) {
      this.lastPageValue = value;
      this.listQueryData = value.record;
      console.log("协诊详情======",value)
      if(this.listQueryData.codiagDealResult == "线上协诊") {
        // this.listQueryData.sportPeriodGuides = !this.listQueryData.sportPeriodGuides ? "" : this.listQueryData.sportPeriodGuides.join(';');
        if(this.listQueryData.sportPeriodGuides != null){
          this.listQueryData.sportPeriodGuides = this.listQueryData.sportPeriodGuides.join(';');
        }else{
          this.listQueryData.sportPeriodGuides = "";
        }
        // this.listQueryData.dietGuides = !this.listQueryData.dietGuides ? "" : this.listQueryData.dietGuides.join(';');
        if(this.listQueryData.dietGuides != null){
          this.listQueryData.dietGuides = this.listQueryData.dietGuides.join(';');
        }else{
          this.listQueryData.dietGuides = "";
        }
        if(this.listQueryData.medicines.length > 0) {
          this.listQueryData.medicines.forEach((item, index) => {
            item.remarks = !item.remarks ? "" : item.remarks.join(";");
          })
        }
      } else if(this.listQueryData.codiagDealResult == "门诊") {
        this.listQueryData.exams = !this.listQueryData.exams ? "" : this.listQueryData.exams.join(';');
        this.listQueryData.tests = !this.listQueryData.tests ? "" : this.listQueryData.tests.join(';');
      } else if(this.listQueryData.codiagDealResult == "住院") {
        this.listQueryData.inpatientGuides = !this.listQueryData.inpatientGuides ? "" : this.listQueryData.inpatientGuides.join(';');

      }
      this.showDialog = true;
    },
    setDialogClosed() {
      this.showDialog = false;
    }
  }

}
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;
}

::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 120px;
  }
}
</style>